import { useState, useLayoutEffect, useRef } from 'react';

import { requestFullscreen, exitFullscreen, getFullscreenObject, getIsFullscreen } from './utils';

type UseFullscreenState = [boolean, () => void, () => void, () => void, any];

const useFullscreen = (): UseFullscreenState => {
  const fullscreenRef: React.MutableRefObject<any> = useRef();
  const fullscreenObject = getFullscreenObject();

  const [isFullscreen, setIsFullscreen] = useState(getIsFullscreen());

  const enableFullscreen = () => {
    if (fullscreenRef.current) fullscreenObject && requestFullscreen(fullscreenRef.current);
  };

  const disableFullscreen = () => {
    exitFullscreen();
  };

  const toggleFullscreen = () => {
    return isFullscreen ? disableFullscreen() : enableFullscreen();
  };

  const handleFullscreenChange = () => {
    setIsFullscreen(getIsFullscreen());
  };

  useLayoutEffect(() => {
    if (fullscreenObject) {
      document.addEventListener(fullscreenObject.change, handleFullscreenChange);
    }

    return () => {
      if (fullscreenObject) {
        document.removeEventListener(fullscreenObject.change, handleFullscreenChange);
      }
    };
  });

  return [isFullscreen, enableFullscreen, disableFullscreen, toggleFullscreen, fullscreenRef];
};

export default useFullscreen;
